import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { WelcomeTourDialogComponent } from './welcome-tour-dialog.component';

@NgModule({
  declarations: [WelcomeTourDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule],
  exports: [WelcomeTourDialogComponent],
  entryComponents: [WelcomeTourDialogComponent],
})
export class WelcomeTourDialogModule {}
